import React from "react";
import styled, { css } from "styled-components";

import { IStyledItemProps, IItemProps } from "./interfaces";

const StyledItem = styled.div<IStyledItemProps>`
    display: inline;
    font-size: 14px;

    color: ${p => (p.link ? p.theme.c.active : (p.theme.mode === "dark" ? p.theme.c.snowOnActive : p.theme.c.dark))};
    ${p => css`
        margin-right: ${p.marginRight}px;
    `}
`;

const StyledArrow = styled.div`
    display: inline;
    margin: 0 8px;
    font-size: 14px;

    svg {
        fill: none;
        stroke: ${p => p.theme.c.pale};
    }
`;

export const Arrow = () => (
    <StyledArrow>
        <svg width={6} height={10}>
            <polygon points="1,1 5,5 1,9 5,5" />
        </svg>
    </StyledArrow>
);

export const Item = ({ name, marginRight = 0, link, lang }: IItemProps) => (
    <StyledItem marginRight={marginRight} link={link} lang={lang}>
        {name}
    </StyledItem>
);
